import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import CustomInput from "../components/CustomInput";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../features/user/userSlice";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import LoginSignUpModal from "./LoginSignUpModal";

let loginSchema = yup.object({
  email: yup
    .string()
    .required("Email is Required")
    .email("Email Should be valid"),

  password: yup.string().required("Password is Required"),
});

const Login = () => {
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: (values) => {
      dispatch(loginUser(values));

      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    },
  });
  useEffect(() => {
    if (authState.user !== null && authState.isError === false) {
      window.location.href = "/";
    }
  }, [authState]);

  return (
    <>
      <Meta title={"Login"} />
      <BreadCrumb title="Login" />
      <button
  className="button"
  data-bs-toggle="modal"
  data-bs-target="#loginSignUpModal"
>
  Login / Signup
</button>
<LoginSignUpModal />
      <Container class1="login-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="auth-card">
              <h3 className="text-center mb-3">Login</h3>
              <form
                action=""
                onSubmit={formik.handleSubmit}
                className="d-flex flex-column gap-15"
              >
                <CustomInput
                label="Email"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange("email")}
                  onBlur={formik.handleBlur("email")}
                />
                <div className="error">
                  {formik.touched.email && formik.errors.email}
                </div>
    <div className="position-relative">
                  <CustomInput
  label="Password"
  type={showPassword ? "text" : "password"}
  name="password"
  placeholder="Password"
  value={formik.values.password}
  onChange={formik.handleChange("password")}
  onBlur={formik.handleBlur("password")}

/>
        <div
          className="position-absolute"
          onClick={() => setShowPassword(!showPassword)}
          style={{
            top: "65%",
            right: "10px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "20px",
            color: "#888",
          }}
        >
          {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
        </div>
      </div>
    
                <div className="error">
                  {formik.touched.password && formik.errors.password}
                </div>
                <div>
                  <Link to="/forgot-password">Forgot Password?</Link>

                  <div className="mt-3 d-flex justify-content-center gap-15 align-items-center">
                    <button className="button border-0" type="submit" >
                      Login
                    </button>
                    {/* <Link to="/signup" className="button signup">
                      SignUp
                    </Link> */}
                  </div>
                  <p className="m-4 text-center">Don't hava an account ?.Create a new account <Link to="/signup" >Register</Link></p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Login;
